// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2379":"bb760c09550f2b44","4971":"1b5ef5691516f7e2","7187":"729efc713fa5201f"}[chunkId] + ".css";
};